import React, { useState } from "react";
import {
  TextField,
  IconButton,
  //makeStyles,
  Typography,
  Box,
} from "@mui/material";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import { blackcolor, pcolor, rcolor, whitecolor } from "../../style2";


const titletext = {
  fontWeight: 500,
  fontSize: 14,
  color: pcolor,
  marginBottom: "10px",
};
const register = {
  width: "100%",
  "& input::placeholder": {
    fontSize: 14,
  },
};
const registertextfieldrequired = {
  borderRadius: 2,
  border: `0.5px solid ${rcolor}`,
  boxSizing: "border-box",
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: rcolor
  }
};
const registertextfieldoptional = {
  background: "rgba(17, 92, 113, 0.04)",
  borderRadius: 2,
  border: "0.5px solid grey",
  margin: "auto",
};
const registerpasswordicon = {
  color: rcolor,
  "&:hover": {
    backgroundColor: whitecolor,
  },
  padding: 0,
};

const textFieldDisabled = {
  color: blackcolor,
  background: whitecolor,
};
const textFieldOutlineDisabled = {
  border: "none",
  background: "rgba(17, 92, 113, 0.04)",
};

function Textfield({
  title,
  id,
  required,
  password,
  value,
  name,
  disabled,
  placeholder,
  onChange,
  errorBoolean,
  helperText,
  rows = 0,
  maxCharacterLimit = 24,
}) {
  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => setShowPassword(!showPassword);

  // Choose sx for TextField
  let textFieldSx = { ...register };
  if (required && password) {
    textFieldSx = { ...textFieldSx, ...registertextfieldrequired };
  } else if (required) {
    textFieldSx = { ...textFieldSx, ...registertextfieldrequired };
  } else if (disabled) {
    textFieldSx = { ...textFieldSx, ...textFieldOutlineDisabled, ...textFieldDisabled };
  } else {
    textFieldSx = { ...textFieldSx, ...registertextfieldoptional };
  }

  return (
    <div>
      <Typography sx={titletext}>{title}</Typography>
      <Box m={1} />
      <TextField
        variant='outlined'
        id={id}
        size={"small"}
        placeholder={placeholder}
        sx={textFieldSx}
        name={name}
        type={password ? (showPassword ? "text" : "password") : undefined}
        value={value}
        disabled={disabled}
        onChange={onChange}
        error={errorBoolean}
        helperText={helperText}
        multiline={rows > 1 ? true : false}
        minRows={rows}
        inputProps={{ maxLength: maxCharacterLimit }}
        InputProps={
          required && password
            ? {
                endAdornment: (
                  <IconButton
                    sx={registerpasswordicon}
                    aria-label='toggle password visibility'
                    onClick={handleClickShowPassword}
                  >
                    {showPassword ? (
                      <VisibilityOffOutlinedIcon />
                    ) : (
                      <VisibilityOutlinedIcon />
                    )}
                  </IconButton>
                ),
              }
            : undefined
        }
      />
    </div>
  );
}
export default Textfield;
